const onlyDownloadableExtensions = ['eml', 'msg', 'txt', 'html', 'zip', 'doc']

export const checkIsOnlyDownloadableFile = (extension: string) => {
  return onlyDownloadableExtensions.some(ext => ext === extension)
}
